import { ENV_VARS } from '@/env';
import _axios from 'axios';
import { API } from '../../api';
import { ExpireTokenInterceptor, addCompanyIdInterceptor, setTokenInterceptor } from '../../redux/interceptors';
import { getLocalTimeZone } from '../../utils/date';
import { deprecate } from '../deprecate';

_axios.create = deprecate(_axios.create, {
  message: `axios.create is deprecated, will be applied wretch vs ky soon.
    By the way we have to use only one instance of axios via the whole project`,
});

export const axiosInstance = _axios.create({
  baseURL: API.BASE,
  headers: {
    'X-Time-Zone': getLocalTimeZone(),
    'X-Client-Version': ENV_VARS.VERSION,
  },
});

axiosInstance.CancelToken = _axios.CancelToken;

axiosInstance.interceptors.request.use(setTokenInterceptor, (error) => Promise.reject(error));
axiosInstance.interceptors.request.use(addCompanyIdInterceptor, (error) => Promise.reject(error));

axiosInstance.interceptors.response.use((config) => config, ExpireTokenInterceptor);
